// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

import { inView } from "motion"
window.inView = inView

import RailsUjs from '@rails/ujs'
RailsUjs.start()

// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()

import ahoy from "ahoy.js";
// require("chartkick")
// require("chart.js")

ahoy.configure({
    urlPrefix: process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://api.webase.com'
})


// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
